import { collection, onSnapshot, query, limit as limitTo, where as whereCond, orderBy as orderByQuery } from "firebase/firestore"
import { useReducer, useEffect } from 'react'
import { db } from '..'
import { showLoader } from '../../utils/loader'

const initialState = {
  hasMore: false,
  after: null,
  limit: 0,
  docs: [],
  items: [],
  lastLoaded: null,
  loading: true,
  loadingError: null,
  loadingMore: false,
  loadingMoreError: null
}

const reducer = (state, action) => {
  switch (action.type) {
    case "LOADED": {
      let snapDocs = [...state.docs]
      let isAdding = false
      action.value.docChanges().forEach(change => {
        if (change.type === "added") {
          isAdding = true
          addItem(change.doc, snapDocs)
        }
        else if (change.type === "modified") {
          updateItem(change.doc, snapDocs)
        }
        else if (change.type === "removed") {
          deleteItem(change.doc, snapDocs)
        }
      })
      const nextLimit = snapDocs.length + action.limit
      let end = snapDocs.length < action.limit || nextLimit === state.limit
      var items = []
      snapDocs?.forEach((snapDoc, i) => {
        if (snapDoc.exists) {
          items.push({
            ...snapDoc.data(),
            id: snapDoc.id,
          })
        }
      })

      return {
        ...state,
        hasMore: isAdding ? !end : state.hasMore,
        limit: nextLimit,
        loading: false,
        loadingError: null,
        lastLoaded: action.value.docs[action.value.docs.length - 1],
        loadingMore: false,
        docs: snapDocs,
        items
      }
    }

    case "LOAD-MORE": {
      return {
        ...state,
        loadingMore: true,
        after: state.lastLoaded
      }
    }

    default: {
      return {
        ...state
      }
    }
  }
}

function findIndexOfDocument(doc, docs) {
  return docs.findIndex(item => {
    return item.id === doc.id
  })
}

function updateItem(doc, docs) {
  const i = findIndexOfDocument(doc, docs)
  docs[i] = doc
}

function deleteItem(doc, docs) {
  const i = findIndexOfDocument(doc, docs)
  docs.splice(i, 1)
}

function addItem(doc, docs) {
  const i = findIndexOfDocument(doc, docs)
  if (i === -1) {
    docs.push(doc)
  }
}

/**
 *
 * @param {*} table
 * @param {*} query
 * @returns
 */
const usePagination = (table, { where = [], between = [], orderBy = [], limit = 20, update = 0 } = {}) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  // when "after" changes, we update our query

  useEffect(() => {
    const tableRef = collection(db, table)
    let queryConstraints = []

    if (where.length >= 2) {
      console.log("where", ...where)
      queryConstraints.push(whereCond(where[0], where[1], where[2]))
    }

    if (between.length >= 2) {
      console.log("between", ...between)
      between[1] && queryConstraints.push(whereCond(between[0], "<=", between[1]))
      between[2] && queryConstraints.push(whereCond(between[0], ">=", between[2]))
    }
    if (orderBy.length > 1) {
      // console.log("orderBy", orderBy[0], orderBy[1])
      queryConstraints.push(orderByQuery(orderBy[0], orderBy[1]))
    } else if (orderBy.length > 0) {
      // console.log("orderBy", orderBy[0])
      queryConstraints.push(orderByQuery(orderBy[0]))
    }
    queryConstraints.push(limitTo(state.limit || limit))

    // console.log(update, ...queryConstraints)
    const unsubscribe = onSnapshot(query(tableRef, ...queryConstraints), querySnapshot => {
      dispatch({ type: "LOADED", value: querySnapshot, limit: limit })
    })

    return () => unsubscribe()
    // eslint-disable-next-line
  }, [state.after, update])
  // trigger firebase to load more

  useEffect(() => {
    showLoader(state.loading)
  }, [state.loading])

  useEffect(() => {
    if (state.loadingError) {
      showLoader(false)
    }
  }, [state.loadingError])

  const loadMore = () => {
    dispatch({ type: "LOAD-MORE" })
  }

  return {
    loadingMore: state.loadingMore,
    loadingError: state.loadingError,
    loadingMoreError: state.loadingMoreError,
    loading: state.loading,
    hasMore: state.hasMore,
    items: state.items,
    docs: state.docs,
    loadMore
  }
}

export default usePagination
